export function externalNavigate(url) {
    window.location.href = url;
    return null;
}